import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { LoginComponent, isAuthenticated } from '@rsmu/auth';
import { AuthComponent } from './core/components/auth/auth.component';
import { STUDENT_CABINET_ROUTES } from './features/student-cabinet/student-cabinet.routes';
import { CourseListComponent } from './shared/components/course-list/course-list.component';

export const APP_ROUTES: Routes = [
  { path: 'courses',canActivate: [isAuthenticated], component: CourseListComponent, pathMatch: 'full' },
  { path: 'auth', component: AuthComponent },
  { path: 'login', component: LoginComponent },
  {
    path: ':moduleId',
    children: [
      { path: '', redirectTo: 'student-cabinet', pathMatch: 'full' },
      { path: 'student-cabinet', children: STUDENT_CABINET_ROUTES }
    ]
  },
  { path: '**', component: PageNotFoundComponent }
];